import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Notification, NotificationService } from 'src/app/core/http/apiNotify/notificaciones.service';
import { SessionStorageService } from 'src/app/core/services/session-storage/session-storage.service';

@Component({
  selector: 'app-button-menu-header',
  templateUrl: './button-menu-header.component.html',
  styleUrls: ['./button-menu-header.component.scss']
})
export class ButtonMenuHeaderComponent implements OnInit , OnDestroy{
  private _onDestroy = new Subject();

  notifications: Notification;
  notifications$: Observable<Notification>;
  public subscription: Subscription;
  public icon : any;
  public claims;
  public numberNotification: number;
  @Input() disabledNotification = true;
  markAsRead: boolean
  constructor(private notificationService: NotificationService, private sessionStorageService: SessionStorageService) {
    this.icon = {name: 'menu'}
    this.claims = this.sessionStorageService.get('claims');
    this.markAsRead = true;
    
   }
  

  ngOnInit(): void {
    this.numberNotification = this.sessionStorageService.get('notification');
    this.notifications$ = this.notificationService.getNotifications$();
    this.notifications$.subscribe(resp => {
      this.numberNotification = resp.numbers;
    });
  }

  refreshNotification(){
  }
  ngOnDestroy(): void {
  }
}
